import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AirportComment } from '../models/airport-comment.model';


@Injectable()
export class RemarkService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }

  /**
   * gets admin comments via api
   * @param {number} airportID
   * @return {Promise<Array<AirportComment>>}
   */
  async getRemarks(airportID: number): Promise<Array<AirportComment>> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/comments`;
    try {
      const RESPONSE = await this._http.get<any>(URL).toPromise();
      const AIRPORT_ADMIN_COMMENTS = (RESPONSE || []).map(d => AirportComment.parse(d));
      // const AIRPORT_ADMIN_COMMENTS = AirportComment.parse(RESPONSE);
      return AIRPORT_ADMIN_COMMENTS;
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * updates specified entity via api
   * @param {number} airportID
   * @param {AirportComment} remark
   * @return {Promise<any>}
   */
  putRemark(airportID: number, remark: AirportComment): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/comments/${remark.id}`;
    try {
      const BODY = this._getRemarkJSON(remark);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * adds specified entity via api
   * @param {number} airportID
   * @param {AirportComment} remark
   * @return {Promise<any>}
   */
  postRemark(airportID: number, remark: AirportComment): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/comments/`;
    try {
      const BODY = this._getRemarkJSON(remark);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * deletes specified entity via api
   * @param {number} airportID
   * @param {number} remarkID
   * @return {Promise<any>}
   */
  deleteRemark(airportID: number, remarkID: number): Promise<any> {
    const URL = `${environment.airportsApiUrl}/airports/${airportID}/comments/${remarkID}`;
    try {
      return this._http.delete(URL).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts entity to json obj
   * @param {AirportComment} remark
   * @return {any}
   * @private
   */
  _getRemarkJSON (remark: AirportComment): any {
    return {
      commentType: AirportComment.formatCommentType(remark.commentType),
      commentRef: remark.commentRef,
      text: remark.text
    };
  }
}
